module.exports = __webpack_public_path__ + "static/media/success-icon.b80c2bc8.ico";